import {
    USER_REQUEST,
    USER_RECEIVE,
    USER_INVALIDATE,
    USER_TASKS_REQUEST,
    USER_TASKS_RECEIVE,
    USER_SET_AVAILABLE_REQUEST,
    USER_SET_AVAILABLE_RECEIVE,
    USER_SET_SUBJECTS_REQUEST,
    USER_SET_SUBJECTS_RECEIVE,
    USER_SET_FIELD_REQUEST,
    USER_SET_FIELD_RECEIVE,
    USER_SET_FIELD,
    USER_FILE_UPLOAD_REQUEST,
    USER_FILE_UPLOAD_PROGRESS,
    USER_FILE_UPLOAD_RECEIVE,
    USER_ACTION_REQUEST,
    USER_ACTION_RECEIVE,
} from './actions';

import moment from 'moment-timezone';

const tasks = (state = {}, action) => {
    switch (action.type) {
        case USER_TASKS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case USER_TASKS_RECEIVE:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.tasks
            });
        default:
            return state;
    }
};

const file = (state = {}, action) => {
    switch (action.type) {
        case USER_FILE_UPLOAD_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                progress: 0,
                name: action.fileName
            });
        case USER_FILE_UPLOAD_PROGRESS:
            return Object.assign({}, state, {
                isFetching: true,
                progress: action.progress
            });
        case USER_FILE_UPLOAD_RECEIVE:
            return Object.assign({}, state, action.data, {
                isFetching: false,
                progress: null
            });
        default:
            return state;
    }
};

const user = (state = {
    didInvalidate: true,
    fetchingFields: []
}, action) => {
    switch (action.type) {
        case USER_INVALIDATE:
            return Object.assign({}, state, {
                didInvalidate: true
            });
        case USER_REQUEST:
            return Object.assign({}, state || {}, {
                isFetching: true,
                didInvalidate: false
            });
        case USER_RECEIVE:
            moment.tz.setDefault(action.user.timezone_str);
            return Object.assign({}, state, action.user, {
                isFetching: false,
                didInvalidate: false,
                showAgreementWizard: !action.user.profile_tag_policies_agree || !action.user.profile_tag_terms_agree
            });
        case USER_TASKS_REQUEST:
        case USER_TASKS_RECEIVE:
            return Object.assign({}, state, {
                tasks: tasks(state.tasks, action)
            });
        case USER_SET_AVAILABLE_REQUEST:
            return Object.assign({}, state, {
                isFetchingAvailable: true
            });
        case USER_SET_AVAILABLE_RECEIVE:
            return Object.assign({}, state, action.data, {
                isFetchingAvailable: false
            });
        case USER_SET_SUBJECTS_REQUEST:
            return Object.assign({}, state, {
                subjects: action.subjects,
                isFetchingSubjects: true
            });
        case USER_SET_SUBJECTS_RECEIVE:
            return Object.assign({}, state, action.data, {
                isFetchingSubjects: false
            });
        case USER_SET_FIELD_REQUEST:
            return Object.assign({}, state, {
                [action.name]: action.value,
                fetchingFields: [...state.fetchingFields, action.name]
            });
        case USER_SET_FIELD_RECEIVE:
            return Object.assign({}, state, action.data, {
                fetchingFields: state.fetchingFields.filter(field => field !== action.name)
            });
        case USER_SET_FIELD:
            return Object.assign({}, state, {
                [action.name]: action.value
            });
        case USER_FILE_UPLOAD_REQUEST:
        case USER_FILE_UPLOAD_PROGRESS:
        case USER_FILE_UPLOAD_RECEIVE:
            return Object.assign({}, state, {
                [action.fileType]: file(state[action.fileType], action)
            });
        case USER_ACTION_REQUEST:
            return {
                ...state,
                isFetchingAction: true
            };
        case USER_ACTION_RECEIVE:
            return {
                ...state,
                ...action.data,
                isFetchingAction: false
            };
        default:
            return state;
    }
};

export default user;


// WEBPACK FOOTER //
// ./src/store/user/reducers.js